import React from "react";

export default function TermsConditions() {
  const effectiveDate = new Date().toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
  return (
    <div className="container-fluid maxContainerSection paddingTop">
      <div className="row commonPadding alignCenterSection">
        <div className="col-md-10">
          <div className="policyHeader">
            <h2 className="m-0 headingTwo">Terms & Conditions</h2>
            <p className="m-0 peraGraph">Effective Date : {effectiveDate}</p>
            <p className="m-0 peraGraph">By using Miaxa, you agree to the following terms:</p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">1. Acceptance of Terms</h3>
            <p className="m-0 spanText">
              By accessing or using Miaxa, you agree to comply with these Terms.
            </p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">2. User Accounts</h3>
            <ul>
              <li>You must provide accurate information.</li>
              <li>You are responsible for maintaining account security.</li>
              <li>You must not share your login credentials.</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">3. Use of Location Services</h3>
            <ul>
              <li>Miaxa requires location access for core functionality.</li>
              <li>Disabling location may limit features.</li>
              <li>You agree to allow location tracking while using the app.</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">4. Prohibited Activities</h3>
            <p className="m-0 spanText">You agree NOT to:</p>
            <ul>
              <li>Use the app for illegal purposes</li>
              <li>Provide false information</li>
              <li>Attempt to hack or disrupt the app</li>
              <li>Harass other users</li>
              <li>Misuse location data</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">5. User Content</h3>
            <p className="m-0 spanText">If you upload content (reviews, images, etc.):</p>
            <ul>
              <li>
                You grant Miaxa a license to use it for app functionality.
              </li>
              <li>You are responsible for the content you post.</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">6. Third-Party Services</h3>
            <p className="m-0 spanText">Miaxa may use:</p>
            <ul>
              <li>Map services (Google Maps or similar)</li>
              <li>Payment providers</li>
              <li>Analytics tools</li>
            </ul>
            <p className="m-0 spanText">We are not responsible for third-party services.</p>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">7. Limitation of Liability</h3>
            <p className="m-0 spanText">Miaxa is provided “as is.”</p>
            <p className="m-0 spanText">We are not liable for:</p>
            <ul>
              <li>Service interruptions</li>
              <li>Inaccurate location results</li>
              <li>Loss of data</li>
              <li>Damages arising from app use</li>
            </ul>
          </div>

          <div className="policyContent">
            <h3 className="m-0 headerThree">8. Termination</h3>
            <p className="m-0 spanText">We may suspend or terminate accounts if:</p>
            <ul>
              <li>Terms are violated</li>
              <li>Fraudulent activity is detected</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
